import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NavigationIcon(props: IconProps) {
    return <Icon {...props} iconKey={"navigation"}/>
}
